export default __webpack_public_path__ + "static/media/review_.6439c1c4.png";